import { HvacIcon } from './HvacIcon';

/**
 * author: Google
 * id EE07113F-BD81-424C-B228-7EC802F7CFB2
 * name hvac
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hvac.svg
 * tags
 * - Home Automation 
 */
export const VentilationIcon = HvacIcon;
export default VentilationIcon